module.exports = __webpack_public_path__ + "img/mastercard.ea85d502.svg";